"use strict";
module.exports = Math.sign || function sign(x) {
  var n = +x;
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};
